import React = require('react');

interface IHonorsProps {
    items:Array<IItem>
    itemChangeHandler:Function
    viewMode:boolean
}

export interface IItem{
	date:string;
	name:string;
}

export interface IHonorsState {
}

export class Honors extends React.Component<IHonorsProps, IHonorsState>{

  	constructor(props:IHonorsProps){
        super(props);
    }

	private getEmpty():IItem{
		return {
			date: '',
			name: ''
		};
	}

	private addNewRowHandler(evt): void {
		evt.preventDefault();
		var items = this.props.items;
		var newItem:IItem = this.getEmpty();
		if (  items.indexOf(newItem) === -1 ) {
			items.push(newItem);
			this.props.itemChangeHandler(items);
		}
	}

	private itemChangeHandler(evt, item:IItem, field:string): void {
		evt.preventDefault();
		var items = this.props.items;
		var currentIndex:number = items.indexOf(item);
		items[currentIndex][field] = evt.target.value;
		this.props.itemChangeHandler(items);
	}

    render() {
        return (
            <div className="moreItems">
				<div className="list">
					{
						this.props.items.map((item:IItem, key) => {
                             if (this.props.viewMode === true) {
                                return <div key={key}>
                                    { item.date } <span className="ml10">{ item.name }</span>
                                </div>
                            }
							return <div className="row" key={key}>
								<div className="box">
									<input type="text" value={ item.date } placeholder="Dátum" onChange={ e => this.itemChangeHandler(e, item, 'date') } />
								</div>
								<div className="box p5">
									<input type="text" value={ item.name } placeholder="Megnevezés" onChange={ e => this.itemChangeHandler(e, item, 'name') } />
								</div>
							</div>
						})
					}
				</div>
				{ this.props.viewMode === false?<div className="row col3">
					<div className="box"></div>
					<div className="box"></div>
					<div className="box right">
						<button className="btn addBtn" onClick={ e => this.addNewRowHandler(e) }> + Új sor</button>
					</div>
				</div>:'' }
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/edit_item/Honors.tsx